import type { Blocker } from '@/api/orders';

/**
 * What unblocks each code — the tooltip behind a blocker's short text. The
 * server sends the code, the clause and the figures; the explanation lives
 * here once, instead of being repeated as a sentence on the rail, the report
 * and the queue row.
 */
export const BLOCKER_HELP: Record<string, string> = {
  duty_unattributed: 'Attach the carrier duty bill in Duties, or waive it there if none is coming.',
  charge_mismatch: 'Subtotal plus itemised charges does not reach the invoice total; a freight, duty or fee line is missing from the capture.',
  invoice_self_mismatch: 'The invoice lines do not extend to its stated subtotal; a unit cost, quantity or pack grain was captured wrong.',
  invoice_missing: 'No invoice is recorded against this receiving.',
  invoice_no_subtotal: 'The invoice has neither a product subtotal nor priced lines, so nothing can be distributed.',
  invoice_total_missing: 'The amount paid is not recorded, so there is nothing to balance against.',
  invoice_lineless: 'Header-only invoices cannot be priced onto products; capture their lines, or accept the vendor as never itemised.',
  distribution_gap: 'Received quantities priced at target do not come back to what was paid; a line, quantity or charge is missing.',
  diff_settle: 'Decide each in Discrepancies: recount, credit, recapture, or let it go.',
  diff_recount: 'The warehouse is verifying the count; the difference clears on the next mirror.',
  diff_recapture: 'The orders run is re-reading the invoice; the difference clears when the lines are re-registered.',
  diff_move: 'Move the products between receivings in the acot backend; the next mirror clears both sides.',
  diff_wait: 'Invoiced products have not arrived yet; nothing to decide.',
  diff_capture_lines: 'The orders run still has to capture these invoice lines.',
  diff_source_invoice: 'Only the vendor portal or the rep can supply the itemised invoice.',
  diff_accept: 'This vendor bills header-only; the receiving cannot be balanced product by product.',
  diff_review: 'Rule on each in Discrepancies: freebie, move off, or re-read the invoice.',
};

export function blockerHelp(blocker: Blocker): string | undefined {
  return BLOCKER_HELP[blocker.code];
}
